import React, { useEffect, useState, useRef } from "react";
import Webcam from "react-webcam";
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import BackgroundTheme from "../../../Common/P2P/Header/BackgroundTheme";
import RoundButton from "../../../Common/RoundButton";
import { Field, Form, Formik } from "formik";
import { InputType } from "../../../Common/FormFields/InputType";
import {  Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
import ErrorMessage from "../../../Common/ErrorMessage";
const KycDocumentForm = ({
  manualKycImage,
  handleRetake,
  initialValues,
  validationSchema,
  onSubmitHandle,
  onChangeField,
  manualKycError
}: any) => {
  return (
    <>
      <div style={{ marginTop: "35px", marginBottom: "30px" }}>
        {
          manualKycImage !== undefined ?
            <img src={manualKycImage} />
            :
            <img
              src={
                "https://4.imimg.com/data4/YY/RM/ANDROID-46835023/product-250x250.jpeg"
              }
            />
        }
      </div>
      <Typography className="fs-14">
        Make sure you place your PAN card inside the frame as shown as above
      </Typography>

      <Box className="contentAreaPersonal">
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(value) => onSubmitHandle(value)}
        >
          {({ handleSubmit, values, touched, errors }) => (
            <Form>
              <div style={{ marginTop: "20px" }}>
                <Field
                  component={InputType}
                  type="text"
                  placeholder="enter your PAN card no"
                  name="pancardNo"
                  value={values.pancardNo}
                  onChange={onChangeField}
                />
              </div>
              {
                manualKycError?.error && (
                  <ErrorMessage text={manualKycError?.error} />
                )
              }
              <div className="kyc-btn-view continue-white-btn">
                <RoundButton onClick={handleRetake} title={"Retake"} />
                <RoundButton type="submit" title={"Continue"} />
              </div>
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};

export default KycDocumentForm;